import { SET_QUESTIONS_ANSWERS, SET_REASON_OF_UNSATISFIED_RESPONSE } from "../actions/QuestionsAndAnswers";

export const initialState = {
	questionsAndAnswers : [],
	reasonOfUnsatisfiedResponse: ""
};

const questionsAndAnswers = (state = initialState, action = {}) => {
	switch (action.type) {
	case SET_QUESTIONS_ANSWERS : {
		return {
			...state,
			questionsAndAnswers: action.obj
		};
	}
	case SET_REASON_OF_UNSATISFIED_RESPONSE : {
		return {
			...state,
			reasonOfUnsatisfiedResponse: action.value
		};
	}
	default:
		return state;
	}
};

export default questionsAndAnswers;